import { isBusiness } from 'owa-session-store';

/**
 * Refers to the enum specified in SharedABT module: @webauthjs/microsoft.office.webauth.abt
 * Doc: https://www.owiki.ms/wiki/ICE_Services/WebAuth/JS/abt
 */
enum AuthType {
    Aad = 1,
    Msa = 2,
}

export function getAuthType(): AuthType {
    return isBusiness() ? AuthType.Aad : AuthType.Msa;
}
